import React, { useEffect, useCallback } from "react";
import { useRouter } from "next/router";
import { Box, Typography } from "@bca/ui-library";
import { FilterAsCheckbox } from "./FilterAsCheckbox";
import addFiltersToPageUrl from "./addFiltersToPageUrl";
import SelectGroup from "./SelectGroup";
import { filterDisclaimers } from "./filtersConfig";

let timer;

const CAPCleanPriceFilter = ({
  appliedCheckboxes,
  setAppliedCheckboxes,
  setSelectedVehicles,
  rangeSubfilters,
  searchResultsLoading,
}) => {
  const router = useRouter();

  const debounceUrlUpdate = useCallback(() => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const newUrl = addFiltersToPageUrl("bq", appliedCheckboxes);
      const currentPageUrl = new URL(window.location.href);
      if (newUrl.href === currentPageUrl.href) {
        return;
      }
      newUrl.searchParams.delete("page");
      newUrl.searchParams.delete("vrm");
      router.push(newUrl.href, newUrl.href, { shallow: true });
    }, 1000);
  }, [appliedCheckboxes, router]);

  const stringifiedFilters = JSON.stringify(appliedCheckboxes);
  useEffect(() => {
    debounceUrlUpdate();
  }, [stringifiedFilters, debounceUrlUpdate]);

  const onChangeAwaitingAppraisal = (categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;

    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) => item.categoryKey === categoryKey
    );

    if (filterAlreadyApplied) {
      newState = [
        ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      ];
    } else {
      newState = [
        ...appliedCheckboxes,
        {
          filterKey: "false",
          categoryKey: "awaitingAppraisal",
          groupedBy: "",
          parentFilterKey: "",
        },
      ];
    }

    setAppliedCheckboxes([...newState]);
  };

  const onSelectChange = (filterKey, categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;
    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) => item.categoryKey.toLowerCase() === categoryKey.toLowerCase()
    );

    newState = [
      ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      {
        filterKey: filterKey,
        categoryKey,
        groupedBy: "",
        parentFilterKey: "",
      },
    ];

    setAppliedCheckboxes([...newState]);
  };

  const disclaimerText = filterDisclaimers.find(
    (item) =>
      item.categoryKey === "awaitingAppraisal" &&
      item.filterKey === "Awaiting Appraisal"
  )?.disclaimerText;

  return (
    <Box>
      {rangeSubfilters && (
        <SelectGroup
          rangeSubfilters={rangeSubfilters}
          categoryKey="CapCleanPrice"
          onChange={onSelectChange}
          searchResultsLoading={searchResultsLoading}
          appliedCheckboxes={appliedCheckboxes}
          labels={["Min", "Max"]}
        ></SelectGroup>
      )}
      <Box mt={5}>
        <FilterAsCheckbox
          key="awaitingAppraisal"
          id="awaitingAppraisal"
          label="Include vehicles that do not have pricing information"
          isSelected={
            !Boolean(
              appliedCheckboxes.find(
                (item) =>
                  item.categoryKey === "awaitingAppraisal" &&
                  item.filterKey === "false"
              )
            )
          }
          onChange={() => onChangeAwaitingAppraisal("awaitingAppraisal")}
        />
        {disclaimerText && (
          <Typography
            color="grey-blue"
            variant="caption"
            fontWeight="light"
            ml={9}
            css={`
              max-width: 292px;
            `}
          >
            {disclaimerText}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CAPCleanPriceFilter;
